// extracted by mini-css-extract-plugin
export default {"loading-indicator":"loading-indicator_loading-indicator__ioEKZ"};